export enum OrderStep {
  PropertyAddress = 0,
  BusinessSource,
  OrderType,
  OrderDetails,
  People,
  Documents,
  OrderResult,
}

export enum NewOrderView {
  StepsOverview = 0,
  Forms,
}
